/**
 * Converts camelCase to kebab-case
 */
export const camelToKebab = (s: string): string =>
  s.replaceAll(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();

/**
 * Converts kebab-case to camelCase
 */
export const kebabToCamel = (s: string): string =>
  s.replaceAll(/-([a-z])/g, (_, c) => c.toUpperCase());

/**
 * Attempts to parse a string as JSON with fallback to single-quote format
 */
export const tryParseDataJSON = (raw?: string): unknown => {
  if (raw == null) return undefined;
  const t = String(raw).trim();
  if (!t) return undefined;

  try {
    return JSON.parse(t);
  } catch {
    if (/^[[{]/.test(t)) {
      try {
        return JSON.parse(t.replaceAll("'", '"'));
      } catch {
        return undefined;
      }
    }
    return undefined;
  }
};
